<template>
	<div class="bodywrap">
		<div class="banner clearfix">
			<img width="100%" class="fl" :src='commmonWebConfig.static+"/img/carfestival/publicbanner.png"' alt="" />
		</div>
		<div class="contentwrap">
			<div class="tipText">您可以按照以下步骤关注“团车”</div>
			<div class="bigicon">
				<img :src='commmonWebConfig.static+"/img/carfestival/pubicon.png"' alt="" />
			</div>
			<div class="tipbtnsize">您还可以长按保存图片，扫码关注“团车”</div>
			<div class="codeimg">
				<img :src='commmonWebConfig.static+"/img/carfestival/pubcode.png"' alt="" />
			</div>
		</div>
	</div>
</template>
<script>
	export default {
		name: 'publicpage',
		data: function() {
			return {
				
			}
		},
		beforeCreate: function() {
			getCommonJsIns.initCSS({
				cssURL: "/css/carfestival/publicpage.css"
			});
		},
		mounted: function() {
			var self = this;
			document.title = "公众号页"
				/***统计添加**/
				! function(e, t, n, g, i) {
					e[i] = e[i] || function() {
						(e[i].q = e[i].q || []).push(arguments)
					};
					var n = t.createElement("script");
					var tag = t.getElementsByTagName("script")[0];
					n.async = 1;
					n.src = ('https:' == document.location.protocol ? 'https://' : 'http://') + g;
					tag.parentNode.insertBefore(n, tag);
				}(window, document, "script", "assets.growingio.com/2.1/gio.js", "gio");
			gio('init', '8004d11f5708cccc', {});
			//custom page code begin here
			//custom page code end here
			gio('send');
			gio('enableHT', 'true');
			/***统计添加**/
		},
		methods:{
		 }
	}
</script>


// WEBPACK FOOTER //
// src/views/carfestival/publicpage.vue